/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { lazy } from 'react';
import Students from '../components/students/Students';

const Dashboard = lazy(() => import('../components/dashboard/Dashboard'));
const Grades = lazy(() => import('../components/grades/Grades'));
const AssessmentDetails = lazy(() => import('../components/assessments/details/AssessmentDetails'));

const AssessmentList = lazy(() => import('../components/assessments/AssessmentList'));
const StudentDetail =lazy(()=>import('../components/studentDetail/StudentDetail'))
const Group =lazy(()=>import('../components/groups/Group'))
const StudentAssessment = lazy(() => import('../components/studentAssessment/StudentAssessment'));

const NoSubscription = lazy(() => import('../components/noSubscription/NoSubscription'));

const GroupDetail = lazy(() => import('../components/groupDetail/GroupDetail'))
const Impersonate = lazy(() => import('../components/impersonate/Impersonate'))



export const teacherRoutes = [
  {
    component: Dashboard,
    exact: true,
    path: '/',
    title: 'Dashboard',
  },
  {
    component: Grades,
    path: '/grades',
    title: 'chart',
    exact: true,
  }
  ,
  {
    component: Grades,
    path: '/grades/:testParam',
    title: 'chart',
    exact: true,
  },
  {
    component: AssessmentList,
    path: '/assessments',
    title: 'Assessments',
    exact: true,
  },
   {
     component: AssessmentDetails,
    path: '/assessment/:id',
    title: 'Assessment details',
    exact: true,
  },
  {
    component: Students,
    path: '/students',
    title: 'Students',
    exact: true,
  },
  {
     component: StudentDetail,
     path: '/student/:id',
     title: 'student details',
     exact: true,
   },
  {
    component: Group,
    path: '/groups',
    title: 'Groups',
    exact: true,
  },
  {
    component: StudentAssessment,
    path: '/studentAssessment/:id',
    title: 'student assessments',
    exact: true,
  },
  {
    component: NoSubscription,
    path: '/noSubscription',
    title: 'No Subscription',
    exact: true,
  },
  {
    component: GroupDetail,
    path: '/group/:id',
    title: 'Group detail',
    exact: true,
  },
    {
      component: Impersonate,
    path: '/impersonate',
    title: 'Impersonate',
    exact: true,
  },
 
];

export const noSubscriptionRoutes = [
  
    {
    component: NoSubscription,
    path: '/noSubscription',
    title: 'No Subscription',
    exact: true,
  },
  {
    component: NoSubscription,
    path: '/',
    title: 'No Subscription',
    exact: true,
  }
]